import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "offcanvas-body" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph" }, " Compartilhe qualquer horário específico com seu paciente para agendar uma sessão na sua agenda. ", -1)
const _hoisted_3 = {
  key: 0,
  class: "card mt-4"
}
const _hoisted_4 = { class: "card-header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-header mb-0" }, "Link gerado", -1)
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-check-circle" }, null, -1)
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-copy" }, null, -1)
const _hoisted_11 = { class: "card-body" }
const _hoisted_12 = { class: "text-paragraph mb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_FormButton = _resolveComponent("FormButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_TextInput, {
      required: "",
      label: "Data da sessão",
      model: _ctx.v$.form.date,
      type: "date",
      placeholder: "01/01/2000"
    }, null, 8, ["model"]),
    _createVNode(_component_TextInput, {
      required: "",
      label: "Horário de inicio da sessão",
      model: _ctx.v$.form.time,
      type: "time",
      placeholder: "08:00"
    }, null, 8, ["model"]),
    _createVNode(_component_FormButton, {
      label: "Compartilhar",
      disabled: _ctx.v$.$invalid,
      onOnClick: _ctx.submit,
      form: _ctx.v$.form,
      loading: _ctx.submitting
    }, null, 8, ["disabled", "onOnClick", "form", "loading"]),
    (_ctx.link)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("button", {
              class: _normalizeClass(["btn btn-sm", {
            'btn-outline-primary': !_ctx.linkCopied,
            'btn-success': _ctx.linkCopied,
          }]),
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copyLink && _ctx.copyLink(...args))),
              disabled: _ctx.linkCopied
            }, [
              (_ctx.linkCopied)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                    _hoisted_8,
                    _createTextVNode(" Copiado ")
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_9, [
                    _hoisted_10,
                    _createTextVNode(" Copiar ")
                  ]))
            ], 10, _hoisted_6)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.link), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}